import { ActionKind } from "@glide/common-core/dist/js/database-strings";
import type { TableGlideType } from "@glide/type-schema";
import type { TableMutation } from "@glide/common-core/dist/js/firebase-function-types";
import type { JSONObject } from "@glide/support";

import type { Examples, PropsStrict } from "../types";
import {
    makeAddRowMutation,
    makeDeleteRowMutation,
    makeQueryTableBody,
    makeSetColumnsMutation,
    makeTableMutationBody,
} from "./common";

function makePythonForAPI(url: string, apiKey: string, body: JSONObject, topComment?: string): string {
    let comment = "";
    if (topComment !== undefined) {
        comment = `# ${topComment}\n`;
    }
    return `${comment}import requests

r = requests.post(
    "${url}",
    headers={"Authorization": "Bearer ${apiKey}"},
    json=${JSON.stringify(body, undefined, 4)
        .split("\n")
        .map((l, index) => (index > 0 ? "    " + l : l))
        .join("\n")}
)
result = r.json()`;
}

function makePython(props: PropsStrict, endpoint: string, mutate: (table: TableGlideType) => TableMutation): string {
    return makePythonForAPI(
        props.endpoint(endpoint),
        props.apiKey,
        makeTableMutationBody(props.appID, mutate(props.table))
    );
}

const pythonExamples: Examples = {
    ["Get rows"]: {
        title: "Get rows",
        render: props =>
            makePythonForAPI(
                props.endpoint("queryTables"),
                props.apiKey,
                makeQueryTableBody(props.appID, props.table),
                "Get rows requires Business plan or above"
            ),
    },
    [ActionKind.AddRowToTable]: {
        title: "Add rows",
        render: props => makePython(props, "mutateTables", makeAddRowMutation),
    },
    [ActionKind.SetColumnsInRow]: {
        title: "Edit rows",
        render: props => makePython(props, "mutateTables", makeSetColumnsMutation),
    },
    [ActionKind.DeleteRow]: {
        title: "Delete rows",
        render: props => makePython(props, "mutateTables", makeDeleteRowMutation),
    },
};

export const python = { name: "Python", examples: pythonExamples, syntax: "python" };
